import React, { RefObject } from 'react';
import get from 'lodash/get';

import { Dispatch } from 'app/types/redux';

const getNumberFromPx = (num: string) => Number( num.replace( 'px', '' ) );
const needsPolyfill = !( 'srcdoc' in document.createElement( 'iframe' ) );

interface Props {
    content: string;
    locale: {
        intlCode: string,
    };
    dispatch: Dispatch;
}

interface State {
    height: string;
    locale: string;
}

export default class HtmlContent extends React.Component<Props, State> {
    public state = {
        height: 'auto',
        locale: 'en-US',
    };

    // Need to lift the solution from `srcdoc-polyfill` and change it, if the polyfill is needed, react
    // will *not* change the `srcDoc` attribute to `srcdoc`, and the polyfill is expecting `srcdoc` to work.
    public jsUrl = 'javascript: window.frameElement.getAttribute(\'srcDoc\');';

    public frame = React.createRef() as RefObject<any>;

    public adjustFrame = () => {
        this.setLang();
        this.setState( { height: `${this.getScrollHeight()}px` } );
    }
    public setLang() {
       const html = this.frame.current.contentDocument.getElementsByTagName( 'html' )[ 0 ];
       html.setAttribute( 'lang', get( this.props, 'locale.intlCode' ) );
    }
    public getScrollHeight() {
        const srcDocument = get( this.frame, 'current.contentDocument.body' );
        if ( srcDocument ) {
            const styles = window.getComputedStyle( srcDocument ) as any;
            const margin = getNumberFromPx( styles[ 'margin-top' ] ) + getNumberFromPx( styles[ 'margin-bottom' ] );
            return ( get( this.frame, 'current.contentDocument.body.scrollHeight' ) || 200 ) + margin; // extra pixels to pad content
        }
    }

    public render() {
        const {
            content,
            // tslint:disable-next-line:no-unused
            dispatch,
            ...props
        } = this.props;
        const { height } = this.state;
        return (
            <iframe
                {...props}
                style={{ height }}
                ref={this.frame}
                sandbox="allow-same-origin allow-scripts allow-top-navigation"
                src={needsPolyfill ? this.jsUrl : undefined}
                srcDoc={content}
                onLoad={this.adjustFrame}
            />
        );
    }
}
